import React, { createContext, useState, useContext } from 'react';
import Firebase from '../firebase';
const FirebaseContext = createContext({});
/**
 * A React component that will instantiate a new {@link Firebase} object
 * and put it in the context
 * @param Props - pass firebase config
 */
export const FirebaseProvider = ({ children, config }) => {
    const [firebase] = useState(new Firebase(config));
    return (React.createElement(FirebaseContext.Provider, { value: firebase }, children));
};
/**
 * Use Firebase object in the context
 */
export const useFirebase = () => {
    return useContext(FirebaseContext);
};
//# sourceMappingURL=firebase-context.js.map